<script setup>
// §8.4 BlockerNote — the REASON a day is Unconfirmed (D5a, §3.5.1).
// A blocker is NOT a status and NOT a colour: it is copy in --text-3 beneath
// the chip. "needs a bucket" / "overlaps captured time" are why the day is
// Unconfirmed, never a second chip. Icon is a quiet marker, not a status hue.
import LIcon from '../base/Icon.vue'
defineProps({
  icon: { type: Boolean, default: true },
})
</script>

<template>
  <div class="l-blocker">
    <LIcon name="triangle-exclamation" v-if="icon" :size="12" aria-hidden="true" />
    <span><slot /></span>
  </div>
</template>

<style scoped>
.l-blocker {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 3px;
  font-size: var(--text-chip);
  color: var(--text-3);
}
.l-blocker :deep(i) {
  color: var(--text-3);
  flex: none;
}
</style>
